/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".graph-card[_ngcontent-%COMP%]{min-height:300px}.graph-card[_ngcontent-%COMP%]   .mat-card-content[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
